module.exports = __webpack_public_path__ + "img/case-effect.27c07b23.jpg";